<template>
	<div class="campaigns-subview">
		<ui-root :part="root" :data="data" :readonly="false"></ui-root>
	</div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {ContextKey, getIntValue, injectContext} from "@t/fd/AppContext.ts";
import AgendaPart from "@fd/containers/AgendaPart.vue";
import type {AgendaDefinition} from "@t/fd/layout/Agenda.ts";
import UiRoot from "@fd/containers/UiRoot.vue";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";
import {ColumnType} from "@t/agenda/Columns.ts";
import {ActionFormatterData, IconFormatterData, MapFormatterData, WithFormatterData} from "@t/agenda/CellFormatter.ts";
import {SrcType} from "@t/meta/SourceType.ts";

const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const ap = computed<AgendaDefinition>(()=> {
	return {
		type: "agenda",
		url: "api/campaigns/" + sourceId.value + "/parties",
		fixedColumns: [
			{
				name: "icon", title:"_icon_", type: ColumnType.STRING,
				layout: "LEFT",
				fixedWidth: "22px",
				icon: "ear", thitle: "",
				justify: "CENTER",
				jsonGetters: [ { d: "id" } ],
				format: <ActionFormatterData>{
					type: "ACTION",
					action: "edit",
					srcType: SrcType.CAMPAIGN_PARTY,
					format: <WithFormatterData>{
						type: "WITH",
						format: <IconFormatterData>{ type: "ICON" },
						data: ["ear"]
					},
					params: [ { name: "id", source: "ARG", index: 0 } ]
				}
			}
		]
	}
});

const root = computed<InterfaceRoot<AgendaDefinition>>(() => {
	return {
		type: "interface",
		content: ap.value,

	}
});

const data = computed<any>(() => {
	return { id: sourceId.value };
});
</script>

<style>
.campaigns-subview {
	padding-top: 8px;
}
</style>